var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"main-content bg-black mb-view background-custom",style:({ '--bg-url': `url(${_vm.bgImage})` })},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view',{staticClass:"mb-in-view"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }